<template>
  <div>
    <b-modal
      id="modal-workers"
      content-class="modal-fullscreen"
      body-class="modal-body-fullscreen"
      size="xl"
      ref="modalWorkersSelect"
      :title="title"
      :ok-only="false"
      :no-fade="true"
      @ok="rowClickHandler"
      @cancel="hideModal"
      @close="hideModal"
      @hidden="onHidden"
      ok-title="Добавить в заявку"
      cancel-title="Отменить"
      button-size="sm"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
    >
      <b-row class="mb-0">
        <b-col cols="10">
            <b-card no-body>
              <b-card-body class="py-2">
                <b-row>
                  <b-col cols="auto" class="mr-auto">
                    <b-input-group>
                      <b-form-input size="sm" v-model="query" :placeholder="$t('message.common.search')" @input="onInput"/>
                      <b-input-group-append>
                        <b-button size="sm" variant="info" @click.stop="onSearch()">
                          <font-awesome-icon icon="search"/> Найти
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col cols="auto">
                    <b-form-select
                      id="input_town"
                      size="sm"
                      v-model="currentTown"
                      @change="onTownChange()"
                    >
                      <option :value="-1">Все города</option>
                      <option v-for="option in towns" :key="option.id" :value="option.id">
                        {{ option.name }}
                      </option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-card-body>

              <b-card no-body class="mx-3 mb-2">
                <b-table
                  id="workers"
                  ref="FreeWorkersTable"
                  class="mb-0"
                  striped
                  small
                  hover
                  thead-class="top-fixed-thead thead-light"
                  table-class="text-small"
                  responsive
                  show-empty
                  :empty-text="$t('message.common.emptyTable')"
                  :busy.sync="isBusy"
                  :items="items"
                  :fields="fields"
                  @row-clicked="rowClicked"
                  :tbody-tr-class="tbodyRowClass"
                  no-provider-filtering
                  no-provider-paging
                  no-provider-sorting
                >
                  <template #cell(level_efficiency)="row">
                    <b-badge :id="'level-efficiency-badge-' + row.item.id" pill :variant="getLevelEfficiencyStyle(row.item.level_efficiency)">
                      {{ getLevelEfficiencyText(row.item.level_efficiency)}}
                    </b-badge>
                    <b-tooltip
                      v-if="row.item.description !== ''"
                      :target="'level-efficiency-badge-' + row.item.id"
                      triggers="hover"
                      :variant="getLevelEfficiencyStyle(row.item.level_efficiency)"
                      noninteractive
                    >
                      {{ row.item.description }}
                    </b-tooltip>
                  </template>

                  <template #cell(phone)="row">
                    <a :href=telUrl(row.item.phone)>{{ phoneString(row.item.phone) }}</a>
                  </template>

                  <template #cell(passport_url)="row">
                    <a v-if="row.item.passport_url.length > 0"
                       @click="downloadFile(row.item.id, row.item.passport_url)"
                    >
                      <font-awesome-icon  icon="passport" size="lg" :style="{ color: 'purple' }"/>
                    </a>
                  </template>
                </b-table>
              </b-card>

              <pagination-footer
                :total-rows="totalRows"
                :per-page.sync="perPage"
                @page-click="onPagination"
              >
                <template #footer-list>
                  <div>
                    Всего исполнителей: <b>{{totalRows}}</b>
                  </div>
                </template>
                <template #footer-buttons>
                  <b-pagination
                    pills
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    @page-click="onPagination"
                  />
                </template>
              </pagination-footer>
            </b-card>
        </b-col>
        <b-col cols="2">
          <h6>Будут добавлены: {{ selectedItems.length }}</h6>
          <div v-for="(item, index) in selectedItems" v-bind:key="item.id">
            <small>{{ item.name }}</small>
          </div>
          <hr/>
          <h6>Уже в заявке: {{ tws.length }}</h6>
          <div v-for="(item, index) in tws" v-bind:key="item.id">
            <small>{{ item.name }}</small>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import workers from "../../network/workers";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
  import {debounce} from "lodash";

export default {
  name: "WorkersFree",
  components: { PaginationFooter },
  mixins: [
    workers, catalogs,
    helpers, pageSearchService
  ],
  props: ["date", "end_date", "workers"],
  data() {
    return {
      title: 'Исполнители',
      formUrl: 'workers',
      isBusy: false,
      items: [],
      fields: [
        {
          key: 'name',
          label: this.$t('message.workers.table.name'),
          sortable: true,
          class: 'actions-width'
        },
        {
          key: 'phone',
          label: this.$t('message.workers.table.phone'),
          sortable: true,
        },
        {
          key: 'address',
          label: this.$t('message.workers.table.address'),
          sortable: true,
        },
        {
          key: 'passport_url',
          label: this.$t('message.workers.table.passport'),
          sortable: true,
          formatter: 'existPassport',
        },
        {
          key: 'age',
          label: this.$t('message.workers.table.age'),
          sortable: true,
        },
        {
          key: 'skill',
          label: this.$t('message.workers.table.skill'),
          sortable: true,
        },
        {
          key: 'ready',
          label: this.$t('message.workers.table.ready'),
          sortable: true,
        },
        {
          key: 'level_efficiency',
          label: 'Ур.КПД',
          sortable: true,
          visible: true
        },
      ],
      sortBy: 'last_task_end_date',
      sortDesc: true,
      query: '',
      perPage: 150,
      currentTown: -1,
      disableRouting: true,
      towns: [],
      selectedItems: [],
      tws: [],
      levelEfficiencyOptions: [
        { value: 'high', text: 'Высокий' },
        { value: 'medium', text: 'Средний' },
        { value: 'low', text: 'Низкий' },
      ],
    }
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login').catch(() => {});
      return;
    }

    this.towns = (await this.getTowns({})).data.items;

    await this.getItems();

    this.debouncedSearch = debounce(() => {
      this.onSearch();
    }, 300);
  },
  methods: {
    async showModalSelect() {
      this.tws = this.workers || [];
      this.$refs.modalWorkersSelect.show();
      await this.getItems();
    },
    onHidden() {
      if (this.debouncedSearch) this.debouncedSearch.cancel();

      this.selectedItems = [];
      this.currentTown = -1;
      this.query = '';
    },
    hideModal() {
      this.$refs.modalWorkersSelect.hide();
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query,
        town: this.currentTown,
        active: true,
        level_efficiency: '',
      }

      this.isBusy = true;
      const result = await this.getWorkers(data);

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;

      this.updateSelected();
      this.isBusy = false;
    },
    updateSelected() {
      if (!this.items) return;

      this.items.forEach(item => {
        const isAssigned = this.tws.some(e => e.worker_id === item.id);
        const isSelected = this.selectedItems.some(e => e.id === item.id);

        this.$set(item, 'selected', isSelected);

        item._rowVariant = isAssigned ? 'danger' : '';
      });
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    rowClicked(item) {
      // Ищем уже добавленные в заявку
      if (this.tws.some(e => e.worker_id === item.id)) {
        return;
      }
      // Ищем уже выбранные
      const existItem = this.selectedItems.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.selectedItems.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.selectedItems.push(item);
        this.$set(item, 'selected', true);
      }
    },
    rowClickHandler() {
      this.$emit('addToTask', this.selectedItems);
      this.hideModal();
    },
    existPassport(value) {
      return value.length > 0;
    },
    onInput() {
      this.debouncedSearch();
    },
    async onTownChange() {
      this.currentPage = 1;
      await this.getItems();
    },
    getLevelEfficiencyText(value) {
      const option = this.levelEfficiencyOptions.find(opt => opt.value === value);
      return option.text;
    },
    getLevelEfficiencyStyle(value) {
      switch (value) {
        case 'high':
          return 'success';
        case 'medium':
          return 'warning';
        case 'low':
          return 'danger';
        default:
          return '';
      }
    },
    async downloadFile(id, passportUrl) {
      const fileName = passportUrl.split("/").pop();
      const result = await this.getWorkerFile(id);

      if (result.error || !result.data) {
        this.showError("Ошибка загрузки файла", result.error.message);
        return;
      }

      this.handleFileDownload(result.data, fileName);
    },
  },
}
</script>

<style>
#modal-workers .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkersFree.vue